import { BED_DETAILS_MODULE, DEVICE_TYPES, USER_VIEW } from "../../common/constant/common-constants";

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import patientTypeAdult from "../../common/images/patient_type_adult.svg";
import patientTypePediatric from "../../common/images/patient_type_pediatric.svg";
import patientTypeNeonatal from "../../common/images/patient_type_neonatal.svg";

import { activeDeviceAction } from "../../modules/actions/action";
import { setdeviceViewRedisChannels } from '../../socket/socket';
import PatientRightPanelDesktopView from "./PatientRightPanelDesktopView";
import PatientRightPanelMobileView from "./PatientRightPanelMobileView";



function PatientRightPanel(props) {
    // console.log(props.ventilatorWaveformData);
    const [activeSubHeader, setActiveSubHeader] = useState(props.config.bedDetailConfig.activeModule);
    // const [deviceData, setDeviceData] = useState(null);
    const [bedId, setBedId] = useState(null);

    useEffect(() => {
        let aSubHeader = props.config.bedDetailConfig.activeModule ? props.config.bedDetailConfig.activeModule : BED_DETAILS_MODULE.VITAL_DETAILS;
        setActiveSubHeader(aSubHeader);
    }, [props.config.bedDetailConfig])

    useEffect(() => {
        setBedId(props.bedId);
    }, [props.bedId])

    const handleSubHeaderClick = (item) => {
        setActiveSubHeader(item)
    }

    // useEffect(() => {
    //     setDeviceData(props.deviceData);
    // }, [props.bedDetails, props.bedId])


    useEffect(() => {
        // Prevent overriding if user already selected something
        if (props.config.activeDevice) return;

        // const monitorWifiEnabled = props?.monitorHeartBeatData?.isConnected;
        const monitorHWEnabled = props?.monitorHeartBeatData?.user_enabled;

        // const ventilatorWifiEnabled = props?.ventilatorHeartbeat?.isConnected;
        const ventilatorHWEnabled = props?.ventilatorHeartbeat?.user_enabled

        if (props?.bedDetails?.Noccarc_patientMonitorId && monitorHWEnabled) {
            props.activeDeviceAction(DEVICE_TYPES['NOCCARC_PM_NX5']);
        } else if (props?.bedDetails?.ventilatorId && ventilatorHWEnabled) {
            props.activeDeviceAction(DEVICE_TYPES['VENTILATOR']);
        } else if (props?.bedDetails?.Noccarc_patientMonitorId) {
            props.activeDeviceAction(DEVICE_TYPES['NOCCARC_PM_NX5']);
        } else if (props?.bedDetails?.ventilatorId) {
            props.activeDeviceAction(DEVICE_TYPES['VENTILATOR']);
        }
        else {
            return
        }

    }, [
        props?.monitorHeartBeatData,
        props?.ventilatorHeartbeat,
        props?.config?.activeDevice,
        props?.bedDeatils
    ]);

    useEffect(() => {
        if (props.wardId && props?.bedId && props?.config?.activeDevice) setdeviceViewRedisChannels(props.wardId, props?.bedId, props?.config?.activeDevice);
    }, [props.wardId, props?.bedId, props?.config?.activeDevice]);

    const ventilatorConnected = props?.ventilatorHeartbeat?.isConnected
    const monitorConnected = props?.monitorHeartBeatData
    const user_enabled = props?.ventilatorHeartbeat?.user_enabled
    const ventilationStatus = props?.ventilatorStandby?.ventilationStatus
    const activeVitalDevice = props?.config?.activeDevice
    const ventilatorPatientModeAlarmProfileData = props?.ventilatorPatientModeAlarmProfileData
    const ventilatorAdditionalFeaturesData = props?.ventilatorAdditionalFeaturesData
    const ventilatorModuleConnectionStatus = props?.ventilatorModuleConnectionStatus

    const typeMap = {
        adult: patientTypeAdult,
        neonatal: patientTypeNeonatal,
        pediatric: patientTypePediatric,
    };

    useEffect(() => {
        if (props?.config?.activeDevice === DEVICE_TYPES['NOCCARC_PM_NX5']) {
            if (activeSubHeader === BED_DETAILS_MODULE.PRE_USE_HISTORY) {
                setActiveSubHeader(BED_DETAILS_MODULE.VITAL_DETAILS)
            }
        }
    }, [props?.config?.activeDevice,])

    return (
        <>
            {props.config.userView === USER_VIEW.DESKTOP && (
                <PatientRightPanelDesktopView
                    {...props}
                    bedId={bedId}
                    activeSubHeader={activeSubHeader}
                    handleSubHeaderClick={handleSubHeaderClick}
                    ventilatorConnected={ventilatorConnected}
                    user_enabled={user_enabled}
                    ventilationStatus={ventilationStatus}
                    activeVitalDevice={activeVitalDevice}
                    monitorConnected={monitorConnected}
                    ventilatorPatientModeAlarmProfileData={ventilatorPatientModeAlarmProfileData}
                    ventilatorAdditionalFeaturesData={ventilatorAdditionalFeaturesData}
                    ventilatorModuleConnectionStatus={ventilatorModuleConnectionStatus}
                />
            )}

            {props.config.userView === USER_VIEW.MOBILE && (
                <PatientRightPanelMobileView
                    {...props}
                    bedId={bedId}
                    activeSubHeader={activeSubHeader}
                    handleSubHeaderClick={handleSubHeaderClick}

                    ventilatorConnected={ventilatorConnected}
                    user_enabled={user_enabled}
                    ventilationStatus={ventilationStatus}
                    activeVitalDevice={activeVitalDevice}

                    ventilatorPatientModeAlarmProfileData={ventilatorPatientModeAlarmProfileData}
                    ventilatorAdditionalFeaturesData={ventilatorAdditionalFeaturesData}
                    ventilatorModuleConnectionStatus={ventilatorModuleConnectionStatus}
                />
            )}
        </>
    );

}

const mapStateToProps = (state, ownProps) => {
    let bds = state.bedDetailsReducer.bedDetails
        && state.bedDetailsReducer.bedDetails[ownProps.bedId];
    let pData = state.patientDataReducer.patientData && state.patientDataReducer.patientData[ownProps.bedId];


    let mDataECG = state?.deviceVitalDataReducer?.deviceVitalDataECG?.[ownProps.bedId]?.[DEVICE_TYPES.NOCCARC_PM_NX5];
    let mDataSPO2 = state?.deviceVitalDataReducer?.deviceVitalDataSPO2?.[ownProps.bedId]?.[DEVICE_TYPES.NOCCARC_PM_NX5];
    let mDataNIBP = state?.deviceVitalDataReducer?.deviceVitalDataNIBP?.[ownProps.bedId]?.[DEVICE_TYPES.NOCCARC_PM_NX5];
    let mDataTEMP = state?.deviceVitalDataReducer?.deviceVitalDataTEMP?.[ownProps.bedId]?.[DEVICE_TYPES.NOCCARC_PM_NX5];
    let mHeartBeatData = state?.deviceVitalDataReducer?.monitorHeartbeat?.[ownProps.bedId];
    let mEcgwData = state?.deviceVitalDataReducer?.deviceEcgWaveform?.[ownProps.bedId]?.[DEVICE_TYPES.NOCCARC_PM_NX5];
    let mRespwData = state.deviceVitalDataReducer.deviceRespWaveform
        && state.deviceVitalDataReducer.deviceRespWaveform[ownProps.bedId]
        && state.deviceVitalDataReducer.deviceRespWaveform[ownProps.bedId][DEVICE_TYPES.NOCCARC_PM_NX5];
    let mPlethwData = state.deviceVitalDataReducer.devicePlethWaveform
        && state.deviceVitalDataReducer.devicePlethWaveform[ownProps.bedId]
        && state.deviceVitalDataReducer.devicePlethWaveform[ownProps.bedId][DEVICE_TYPES.NOCCARC_PM_NX5];
    let alarmData = state?.alarmDataReducer?.alarmData?.[ownProps.bedId];

    let ventilatorPatientModeAlarmProfileData = state?.deviceVitalDataReducer?.ventilatorPatientModeAlarmProfileData?.[ownProps.bedId];

    let vAlarmData = state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId] ? state?.alarmDataReducer?.alarmData?.[ownProps.bedId]?.ventilatorAlarms : [];
    let ventilatorAdditionalFeaturesData =
        state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId] ?
            state?.deviceVitalDataReducer?.ventilatorAdditionalFeaturesData?.[ownProps.bedId]?.ventilatorAdditionalFeaturesData
            : [];
    let ventilatorModuleConnectionStatus =
        state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId] ?
            state?.deviceVitalDataReducer?.ventilatorModuleConnectionStatus?.[ownProps.bedId]?.ventilatorModuleConnectionStatus
            : [];
    let ventilatorHeartbeat = state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId];
    let ventilatorStandby = state.deviceVitalDataReducer?.ventilatorStandby?.[ownProps.bedId];
    return {
        bedDetails: bds,
        patientData: pData,
        monitorData_ECG: mDataECG,
        monitorData_SPO2: mDataSPO2,
        monitorData_NIBP: mDataNIBP,
        monitorData_TEMP: mDataTEMP,
        monitorHeartBeatData: mHeartBeatData,
        ventilatorPatientModeAlarmProfileData: ventilatorPatientModeAlarmProfileData,
        alarmData: alarmData,
        ventilatorAlarmData: vAlarmData,
        monitorEcgWaveFormData: mEcgwData,
        monitorRespWaveFormData: mRespwData,
        monitorPlethWaveFormData: mPlethwData,
        config: state.configReducer.config,
        ventilatorHeartbeat: ventilatorHeartbeat,
        ventilatorStandby: ventilatorStandby,
        ventilatorAdditionalFeaturesData: ventilatorAdditionalFeaturesData,
        ventilatorModuleConnectionStatus: ventilatorModuleConnectionStatus,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        activeDeviceAction: (payload) => dispatch(activeDeviceAction(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientRightPanel);
